/**
 * 全局认证中间件
 * 检查用户登录状态，未登录则重定向到首页
 */
export default defineNuxtRouteMiddleware(async (to) => {
  // 白名单：不需要登录就能访问的页面
  const publicPages = [
    '/',           // 首页（登录页）
    '/unauthorized', // 未授权页面
    '/module-preview', // 模块详情预览（嵌入/分享，无需登录）
  ];

  // 练习结果子路径（/result/:id、/result/complete/:id 等）：分享/嵌入可直达，不强制登录
  if (to.path.startsWith('/result/')) {
    return;
  }

  // 如果是白名单页面，直接放行
  if (publicPages.includes(to.path)) {
    return;
  }

  // 在客户端检查登录状态
  if (import.meta.client) {
    const { initAuth, checkAuth } = usePracticeUser();
    
    // 先进行同步检查（基于本地存储）
    const hasToken = checkAuth();
    
    if (!hasToken) {
      // 没有token，重定向到首页
      console.log('用户未登录，重定向到首页');
      return navigateTo('/', { replace: true });
    }
    
    // 如果有token，进行异步验证（验证token是否有效）
    // 注意：这里不等待验证完成，避免阻塞路由导航
    // 如果token无效，会在响应拦截器中处理
    initAuth().catch((error) => {
      console.error('验证token失败:', error);
    });
  }
});

